import { render, staticRenderFns } from "./AyudaTemaBase.vue?vue&type=template&id=bc98940e&scoped=true"
import script from "./AyudaTemaBase.vue?vue&type=script&lang=js"
export * from "./AyudaTemaBase.vue?vue&type=script&lang=js"
import style0 from "./AyudaTemaBase.vue?vue&type=style&index=0&id=bc98940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc98940e",
  null
  
)

export default component.exports